import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AccessSystemService {
  constructor(private http: HttpClient) {}

  private url = environment.url;

  getUserSystems(systemId: string) {
    const url = this.url + 'user/system';
    return this.http
      .get<{ id_visible: string }[]>(url)
      .pipe(map((data) => data.find((d) => d.id_visible == systemId)));
  }
}
